import { connect } from 'react-redux';

import {
    mapDispatchToProps,
    mapStateToProps,
    MyAccountOverlayContainer as SourceMyAccountOverlayContainer
} from 'SourceComponent/MyAccountOverlay/MyAccountOverlay.container';

export {
    mapStateToProps,
    mapDispatchToProps
};

/** @namespace Bodypwa/Component/MyAccountOverlay/Container */
export class MyAccountOverlayContainer extends SourceMyAccountOverlayContainer {
    containerProps() {
        const {
            isOverlayVisible,
            isMobile,
            isLoading: propIsLoading,
            onSignIn
        } = this.props;
        const {
            isLoading: stateIsLoading,
            state,
            isCheckout,
            isPasswordForgotSend
        } = this.state;

        return {
            isCheckout,
            isLoading: propIsLoading || stateIsLoading,
            isMobile,
            isOverlayVisible,
            onSignIn,
            state,
            isPasswordForgotSend
        };
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOverlayContainer);
